import SvgColor from "../../components/svg-color";

import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";
import AppsRoundedIcon from "@mui/icons-material/AppsRounded";
import FastfoodRoundedIcon from "@mui/icons-material/FastfoodRounded";
import TableRestaurantRoundedIcon from "@mui/icons-material/TableRestaurantRounded";
import LibraryBooksRoundedIcon from "@mui/icons-material/LibraryBooksRounded";
import InventoryIcon from "@mui/icons-material/Inventory";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import ReceiptIcon from "@mui/icons-material/Receipt";
import RoomServiceIcon from "@mui/icons-material/RoomService";
import SettingsIcon from "@mui/icons-material/Settings";
import DinnerDiningIcon from "@mui/icons-material/DinnerDining";
import CategoryIcon from "@mui/icons-material/Category";

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

// const NavConfig = () => {
//   const role = localStorage.getItem("role");

//   const navConfig = [
//     {
//       title: "Dashboard",
//       path: "/",
//       icon: icon("ic_analytics"),
//     },

//     // Super Admin Only
//     ...(role === "super-admin"
//       ? [
//           {
//             title: "User",
//             path: "/user",
//             icon: icon("ic_user"),
//           },
//         ]
//       : []),

//     {
//       title: "Food",
//       path: "/food",
//       icon: <FastfoodRoundedIcon />,

//     },

//     {
//       title: "Category",
//       path: "/category",
//       icon: <CategoryIcon />,
//     },

//     // Branch Access
//     ...(["admin", "adminManager", "super-admin", "sub-admin"].includes(role)
//       ? [
//           {
//             title: "Branch",
//             path: "/branch",
//             icon: <AppsRoundedIcon />,
//           },
//         ]
//       : []),

//     // Hotel Brand Management
//     ...(["super-admin", "sub-admin"].includes(role)
//       ? [
//           {
//             title: "Hotel Brand",
//             path: "/hotel",
//             icon: <ApartmentRoundedIcon />,
//           },
//         ]
//       : []),

//     {
//       title: "Orders",
//       path: "/order",
//       icon: <LibraryBooksRoundedIcon />,
//     },

//     // Table Reservations
//     //    SUPER-ADMIN    HOTEL-ADMIN  BRANCH
//     ...(["super-admin", "sub-admin", "branch-admin"].includes(role)
//       ? [
//           {
//             title: "Table",
//             path: "/table",
//             icon: <TableRestaurantRoundedIcon />,
//           },
//         ]
//       : []),

//     {
//       title: "Inventory Management",
//       path: "/inventory-management",
//       icon: <InventoryIcon />,
//     },

//     {
//       title: "Report",
//       path: "/Report",
//       icon: <InsertChartIcon />,
//     },

//     {
//       title: "Invoices",
//       path: "/Invoices",
//       icon: <ReceiptIcon />,
//     },

//     {
//       title: "Waiters",
//       path: "/waiters",
//       icon: <RoomServiceIcon />,
//     },

//     {
//       title: "Kitchen",
//       path: "/Kitchen",
//       icon: <DinnerDiningIcon />,
//     },

//     {
//       title: "Settings",
//       path: "/Settings",
//       icon: <SettingsIcon />,
//     },
//   ];

//   return navConfig;
// };

const NavConfig = () => {
  const role = localStorage.getItem("role");

  if (role === "super-admin") {
    return [
      { title: "User", path: "/user", icon: icon("ic_user") },
      { title: "Branch", path: "/branch", icon: <AppsRoundedIcon /> },
      { title: "Hotel Brand", path: "/hotel", icon: <ApartmentRoundedIcon /> },
      { title: "Settings", path: "/Settings", icon: <SettingsIcon /> },
    ];
  }

  if (role === "admin") {
    return [
      { title: "Dashboard", path: "/", icon: icon("ic_analytics") },
      { title: "User", path: "/user", icon: icon("ic_user") },
      { title: "Branch", path: "/branch", icon: <AppsRoundedIcon /> },
      { title: "Report", path: "/Report", icon: <InsertChartIcon /> },
      { title: "Invoices", path: "/Invoices", icon: <ReceiptIcon /> },
      { title: "Settings", path: "/Settings", icon: <SettingsIcon /> },
    ];
  }

  if (role === "branch-admin") {
    return [
      { title: "Dashboard", path: "/", icon: icon("ic_analytics") },
      { title: "Food", path: "/food", icon: <FastfoodRoundedIcon /> },
       { title: "Category", path: "/category", icon: <CategoryIcon /> },
      { title: "Orders", path: "/order", icon: <LibraryBooksRoundedIcon /> },
      { title: "Table", path: "/table", icon: <TableRestaurantRoundedIcon /> },
      {
        title: "Inventory Management",
        path: "/inventory-management",
        icon: <InventoryIcon />,
      },
      { title: "Report", path: "/Report", icon: <InsertChartIcon /> },
      { title: "Invoices", path: "/Invoices", icon: <ReceiptIcon /> },
      { title: "Waiters", path: "/waiters", icon: <RoomServiceIcon /> },
      { title: "Kitchen", path: "/Kitchen", icon: <DinnerDiningIcon /> },
      { title: "Settings", path: "/Settings", icon: <SettingsIcon /> },
    ];
  }
  return [];
};

export default NavConfig;
